<template>
  <div class="promo__intro section">
    <div class="promo__logo">
      <p class="promo__logo__pretitle">{{ $t("promo.intro.pretitle") }}</p>
      <h1 class="promo__logo__title">{{ $t("promo.intro.title") }}</h1>
      <p class="promo__logo__text">{{ $t("promo.intro.text") }}</p>
    </div>
    <PromoBuyButton :buttonColor="'red'" @showPopup="showPopup" />

    <!-- <video id="video" class="video" autoplay loop preload="auto" muted="" :poster="getPosterImage">
      <source :src="getVideoSrc('bg', 'webm')" type="video/webm" />
      <source :src="getVideoSrc('bg', 'mp4')" type="video/mp4" />
    </video> -->
  </div>
</template>

<script>
import PromoBuyButton from "./PromoBuyButton.vue";

export default {
  name: "PromoPageIntro",

  components: { PromoBuyButton },

  computed: {
    getPosterImage() {
      return require(`@/assets/promo/images/background_promo.jpg`);
    },
  },

  methods: {
    showPopup() {
      this.$emit("showPopup");
    },

    getVideoSrc(name, extension) {
      return require(`@/assets/promo/video/${name}.${extension}`);
    },
  },
};
</script>
